<div>
  <div class="user_manager_row px-3 py-2">
    <div class="row align-items-end mt-3">
      <div class="col-lg-3">
        <form class="form-inline d-flex md-form form-sm">
          <input class="form-control userManager_heading_search form-control-sm mr-3 w-75" (keydown)="onEnterKeySearchUser($event)"
            [(ngModel)]="searchText" type="text" placeholder="Search" name="search" aria-label="Search" />
          <i class="fa fa-search search-icon" (click)="searchUser()" aria-hidden="true"></i>
        </form>
      </div>
      <div class="col-lg-2 p-0">
        <ng-select *ngIf="jurisdictionList.length > 0 && isShowDivisionUser" placeholder="Select division" [items]="jurisdictionList" bindLabel="name" appendTo="body"
          [multiple]="true" (change)="fetchAllUsers()" [(ngModel)]="selectedJuris" style="margin-top: -7px;">
        </ng-select>
      </div>
      <!-- <div class="col-lg-1">
      </div> -->
      <div class="col-lg-4 line-height-1" *ngIf="licensedData.allLicensed > 0">
        <span class="fg-color">Total Licenses: {{licensedData.allLicensed}}</span>
        <span class="fg-color ml-4">Available Licenses: {{licensedData.unUsedLicensed}}</span>
      </div>
      <div class="col-lg-3 line-height-1" [ngClass]="licensedData.allLicensed > 0 ? 'col-lg-2' : 'col-lg-6'">
        <span class="pull-right text-blue pl-3" (click)="downloadUserReport()">
          <span class="fa fa-download"></span> Export Report
        </span>
        <span class="pull-right text-blue pl-3">
          <mat-slide-toggle [checked]="isShowDivisionUser"
                (change)="showDivisionWiseUser()">
              </mat-slide-toggle> <span class="pl-1">Show All Users</span>
        </span>
      </div>
    </div>
  </div>
 
  <div class="row px-3 mt-2">
    <div class="col-lg-12">
      <div class="text-blue mt-2" *ngIf="(userList && (userList.length>0))">
        {{endIndex}} out of {{totalCount}}
      </div>
    </div>
  </div>
  <div class="table-responsive box-shadow setHeight table-cont mt-2" #tableContent>
    <table class="table table-fixed table-hover mb-0" id="regulation-table" style="min-width: 1000px">
      <thead>
        <tr>
          <th class="pointer col-lg-2" (click)="sortUsers('FullName')">User Name
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'FullName' && !filters.IsDesc),
        'fa-sort-amount-desc': (filters.SortKey === 'FullName' && filters.IsDesc) }" aria-hidden="true">
            </i>
          </th>
          <th class="pointer col-lg-2" (click)="sortUsers('EmailId')">Email
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'EmailId' && !filters.IsDesc),
        'fa-sort-amount-desc': (filters.SortKey === 'EmailId' && filters.IsDesc) }" aria-hidden="true">
            </i>
          </th>
          <th class="pointer col-lg-2">Role</th>
          <th class="pointer col-lg-1">Landing Page</th>
          <th class="pointer col-lg-1">Plan Type</th>
          <th class="pointer col-lg-1" (click)="sortUsers('IsActive')">Status
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'IsActive' && !filters.IsDesc),
        'fa-sort-amount-desc': (filters.SortKey === 'IsActive' && filters.IsDesc) }" aria-hidden="true">
            </i>
          </th>
          <th class="pointer col-lg-1">Mobile</th>
          <th class="pointer col-lg-1">User Id</th>
          <th class="pointer col-lg-1 text-center">Action</th>
        </tr>
      </thead>
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <tbody [style.max-height.px]="myInnerHeight">
        <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="20"
          (scrolledIndexChange)="eventHandler()" [style.height.px]="myInnerHeight" *ngIf="userList">
          <div *cdkVirtualFor="let item of userList; let i = index">
            <tr>
              <td class="col-lg-2 p-2">
                <input type="text" class="form-control form-control-sm" [disabled]="loggedInUser.isSAML"
                  [(ngModel)]="item.fullName" value="{{item.fullName}}" />
              </td>
              <td class="col-lg-2 p-2">
                <div class="form-control form-control-sm overflow-auto">{{item.emailId}}</div>
              </td>
              <td class="col-lg-2 p-2 select-group">
                <div class="customSelect">
                  <div class="select">
                    <select class="form-control form-control-sm" [value]="item.roleId" [(ngModel)]="item.roleId"
                      (change)="onRoleChange(item)">
                      <option value="0">Select</option>
                      <option *ngFor="let role of userRoleList" value="{{role.id}}">{{role.displayTitle}}</option>
                    </select>
                  </div>
                </div>
                <span class="fa fa-pencil cursor-pointer edit-icon" (click)="openDialog(item.userId,item.fullName)"></span>
              </td>
              <td class="col-lg-1 p-2">
                <div class="customSelect">
                  <div class="select">
                    <select class="form-control form-control-sm" [value]="item.landingPage"
                      [(ngModel)]="item.landingPage">
                      <option value="0">Select</option>
                      <ng-container *ngFor="let screen of item.userScreenList">
                        <option value="{{screen.id}}" *ngIf="screen.screenUrl">{{screen.title}}</option>
                      </ng-container>
                    </select>
                  </div>
                </div>
              </td>
              <td class="col-lg-1 p-2">
                <div class="customSelect">
                  <div class="select">
                    <select class="form-control form-control-sm" [value]="item.planType" [(ngModel)]="item.planType">
                      <option value="1">Trial</option>
                      <option value="2">Basic</option>
                      <option value="3">Advance</option>
                      <option value="4">Enterprise</option>
                    </select>
                  </div>
                </div>
              </td>
              <td class="col-lg-1 p-2">
                <div class="customSelect">
                  <div class="select">
                    <select class="form-control form-control-sm" [(ngModel)]="item.isActive">
                      <option [value]="true">Active</option>
                      <option [value]="false">InActive</option>
                    </select>
                  </div>
                </div>
              </td>
              <td class="col-lg-1 p-2">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="item.mobile"
                  value="{{item.mobile}}" />
              </td>
              <td class="col-lg-1 p-2 p-0">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="item.userIdByUser" (keypress)="keyPressAlphaNumeric($event)"
                  value="{{item.userIdByUser}}" />
              </td>
              <td class="col-lg-1 p-2 text-center">
                <button class="btn btn-sm bg-g-lightGreen btn-css" (click)="updateUserDetails(item)">Update</button>
              </td>
            </tr>
          </div>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
